import React, {useState} from "react";
import {useQueryClient} from "react-query";
import { Menu } from "@material-ui/core";

import {fetch as fetchAircrafts} from "../../services/aircraft/useAircrafts";
import {fetch as fetchScratchPads} from "../../services/flightPlanning/useSchedulingScratchPads";
import { Icon } from "@material-ui/core";
import {buildMenuItems} from "../IconButtonMenu";
import Icons, { AirplaneClockIcon, AirplaneEventIcon, AirplaneNoteIcon, Messages, ReportsIcon } from "../../icons";
import {MailOutlined, PageviewOutlined, SaveAlt} from "@material-ui/icons";

const buildTripMenu = (trip, aircrafts, editing, canChange, userScratchPads, canViewDetails) => {
  const menuItems = [];
  if (editing && canChange) {
    if (trip.changed && trip.tripState !== "CANCELLED") {
      menuItems.push({action: "undo", itemLabel:"Undo" ,itemIcon: (<Icon>undo</Icon>)});
    }
    if (trip.changed) {
      menuItems.push({action: "undoTrip", itemLabel:"Undo Trip" ,itemIcon: (<Icon>undo</Icon>)});
    }
    if (trip.type === "TRIP" && (trip.tripState === "SCHEDULED")) {
      menuItems.push({action: "editScheduledTime", itemLabel:"Edit Scheduled Departure" ,itemIcon: (<Icon>edit</Icon>)});
    }
    if (trip.type === "TRIP" && trip.tripState !== "CANCELLED") {//(trip.tripState === "SCHEDULED" || trip.tripState === "ESTIMATED")) {
      menuItems.push({action: "editTrip", itemLabel:"Edit Trip" ,itemIcon: (<Icon>edit</Icon>)});
    }
    if (trip.type === "SCHEDULED") {
      menuItems.push({action: "editScheduledTrip", itemLabel:"Edit Trip" ,itemIcon: (<Icon>edit</Icon>)});
    }
    if (trip.type === 'SCHEDULED' || (trip.type === 'TRIP' && (trip.tripState === "SCHEDULED" || trip.tripState === "ESTIMATED"))) {
      menuItems.push({action: "changeTripsAircraft", itemLabel:"Change Trip's Aircraft" ,itemIcon: (<Icon>flight</Icon>), itemMenu: aircrafts && aircrafts.data?aircrafts.data.map(
        (aircraft) => {return {action: "changeTripsAircraft", itemLabel:`${aircraft.aircraftTailNumber}` ,itemIcon: (<Icon>flight</Icon>), extraData: aircraft}}
      ):[]});
    }
    if (!trip.changed && trip.tripState !== "CANCELLED") {
      menuItems.push({action: "cancelTrip", itemLabel:"Cancel Trip" ,itemIcon: (<Icon>delete</Icon>)});
    }
  } else if (editing) {
    if (trip.changed) {
      menuItems.push({action: "Copy change to scratch pad", itemLabel:"Copy changed trip to scratch pad" ,itemIcon: (<Icons>CopyItemIcon</Icons>), itemMenu: userScratchPads && userScratchPads.data?userScratchPads.data.map(
        (userScratchPad) => {return {action: "copyToScratchPad", itemLabel:`Scratch Pad ${userScratchPad.scratchPadNo + 1}`, extraData: userScratchPad}}
      ):[]});
      menuItems.push({action: "Move change to scratch pad", itemLabel:"Move changed trip to scratch pad" ,itemIcon: (<Icons>MoveItemIcon</Icons>), itemMenu: userScratchPads && userScratchPads.data?userScratchPads.data.map(
        (userScratchPad) => {return {action: "moveToScratchPad", itemLabel:`Scratch Pad ${userScratchPad.scratchPadNo + 1}`, extraData: userScratchPad}}
      ):[]});
      menuItems.push({action: "Copy all changes to scratch pad", itemLabel:"Copy all changes to scratch pad" ,itemIcon: (<Icons>copy_all</Icons>), itemMenu: userScratchPads && userScratchPads.data?userScratchPads.data.map(
        (userScratchPad) => {return {action: "copyAllToScratchPad", itemLabel:`Scratch Pad ${userScratchPad.scratchPadNo + 1}`, extraData: userScratchPad}}
      ):[]});
    }
  } else if (canViewDetails === 'ULD'){
    if (trip.type === "TRIP") {
      menuItems.push({action: "uldDocuments", itemLabel:"Documents" ,itemIcon: (<PageviewOutlined/>)});
      menuItems.push({action: "uldMessages", itemLabel:"Messages" ,itemIcon: (<Messages/>)});
    }
  } else if (canViewDetails === true){
    if (trip.type === "TRIP") {
      menuItems.push({action: "addEvent", itemLabel:"Add Delay" ,itemIcon: (<AirplaneEventIcon/>)});
    }
    if (trip.type === "TRIP") {
      menuItems.push({action: "addNote", itemLabel:"Add Note" ,itemIcon: (<AirplaneNoteIcon/>)});
    }
    if (trip.type === "TRIP") {
      menuItems.push({action: "addMovement", itemLabel:"Add Movement" ,itemIcon: (<AirplaneClockIcon/>)});
    }
    if (trip.type === "TRIP") {
      menuItems.push({
        itemLabel:"Trip Sheet",
        itemIcon: (<ReportsIcon/>),
        itemMenu: [
          {action: "downloadTripSheet", itemLabel:"Download Trip Sheet" ,itemIcon: (<SaveAlt/>)},
          {action: "emailTripSheet", itemLabel:"Email Trip Sheet" ,itemIcon: (<MailOutlined/>)},
          {action: "downloadSectorSheet", itemLabel:"Download Sector Sheet" ,itemIcon: (<SaveAlt/>)},
          {action: "emailSectorSheet", itemLabel:"Email Sector Sheet" ,itemIcon: (<MailOutlined/>)},
        ]
      });
      menuItems.push();
    }
    if (trip.type === "TRIP") {
      menuItems.push({action: "documents", itemLabel:"Documents" ,itemIcon: (<PageviewOutlined/>)});
      menuItems.push({action: "messages", itemLabel:"Messages" ,itemIcon: (<Messages/>)});
    }
    if (trip.type === "TRIP" && trip.bloff && !trip.takeoff) {
      menuItems.push({action: "returnToStand", itemLabel:"Return to Stand" ,itemIcon: <Icons>AirplaneReturnIcon</Icons>});
    }
    if (trip.type === "TRIP" && trip.takeoff && !trip.ldg) {
      menuItems.push({action: "diversion", itemLabel:"Add Diversion" ,itemIcon: <Icons>AirplaneDiversionIcon</Icons>});
    }
    if (trip.type === "TRIP" && trip.diverted) {
      menuItems.push({action: "cancelDiversion", itemLabel:"Cancel Diversion" ,itemIcon: <Icons>AirplaneDiversionIcon</Icons>});
    }
  }
  if (trip.type === "TRIP") {
    menuItems.push({
      itemLabel:"Copy to clipboard",
      itemIcon: (<Icons>CopyItemIcon</Icons>),
      itemMenu: [
        {action: "copyFlightAsText", itemLabel:"Copy Flight Scheduled (Text)" ,itemIcon: (<Icons>CopyItemIcon</Icons>)},
        {action: "copyFlightAsHtml", itemLabel:"Copy Flight Scheduled (HTML)" ,itemIcon: (<Icons>CopyItemIcon</Icons>)},
        {action: "copyTripAsText", itemLabel:"Copy Trip Scheduled (Text)" ,itemIcon: (<Icons>copy_all</Icons>)},
        {action: "copyTripAsHtml", itemLabel:"Copy Trip Scheduled (HTML)" ,itemIcon: (<Icons>copy_all</Icons>)},
      ]
    });
  }

  return menuItems;
}

const buildMxMenu = (maintenance) => {
  const menuItems = [];
  if (maintenance.changed) {
    menuItems.push({action: "undo", itemLabel:"Undo" ,itemIcon: (<Icon>undo</Icon>)});
  }
  return menuItems;
}

const ContextMenus = () => {
  const [tripMenuState, setTripMenuState] = useState({
    open: false,
    trip: null,
    x: null,
    y: null,
    callback: null,
    editing: false,
    canChange: false,
    canViewDetails: false
  });

  const [mxMenuState, setMxMenuState] = useState({
    open: false,
    maintenance: null,
    x: null,
    y: null,
    callback: null,
    editing: false,
    canChange: false
  });

  const queryClient = useQueryClient();
  let [aircrafts, setAircrafts] = useState({data: null, loaded: false});
  if (!aircrafts.loaded){
    fetchAircrafts({queryClient, extraKeys:["active"], useCache: true}).then(
      response => {setAircrafts({data:response, loaded: true})}
    );
  }
  let [userScratchPads, setUserScratchPads] = useState({data: null, loaded: false});
  if (!userScratchPads.loaded){
    fetchScratchPads({queryClient, extraKeys:[]}).then(
      response => {setUserScratchPads({data:response, loaded: true})}
    );
  }

  const openTripContextMenu = (trip, x, y, callback, editing=false, canChange=false, canViewDetails=false) => {
    setTripMenuState({open:true, trip, x, y, callback, editing, canChange, canViewDetails});
  }

  const closeTripContextMenu = () => {
    setTripMenuState({open:false, trip:null, x:null, y:null, callback:null, editing: false, canChange: false, canViewDetails: false});
  }

  const openMxContextMenu = (maintenance, x, y, callback, editing=false, canChange=false) => {
    setMxMenuState({open:true, maintenance, x, y, callback, editing, canChange});
  }

  const closeMxContextMenu = () => {
    setMxMenuState({open:false, maintenance:null, x:null, y:null, callback:null, editing: false, canChange: false});
  }

  const handleTripMenuSelection = (event, action, extraData) => {
    const callbackParams = {};
    if (action) {
      callbackParams["tripData"] = tripMenuState.trip;
      callbackParams["selectedAction"] = action;
      callbackParams["selectedOption"] = event.currentTarget.outerText;
      callbackParams["extraData"] = extraData;
      closeTripContextMenu();
      if (tripMenuState.callback) tripMenuState.callback(callbackParams);
    }
  }

  const handleMxMenuSelection = (event, action, extraData) => {
    const callbackParams = {};
    if (action) {
      callbackParams["mxData"] = mxMenuState.maintenance;
      callbackParams["selectedAction"] = action;
      callbackParams["selectedOption"] = event.currentTarget.outerText;
      callbackParams["extraData"] = extraData;
      closeMxContextMenu();
      if (mxMenuState.callback) mxMenuState.callback(callbackParams);
    }
  }

  const TripContextMenu = (props) => {
    if (!tripMenuState.open) {
      return <></>;
    }
    const menuItems = buildTripMenu(tripMenuState.trip, aircrafts, tripMenuState.editing, tripMenuState.canChange, userScratchPads, tripMenuState.canViewDetails);
    if (!menuItems || !Array.isArray(menuItems) || menuItems.length < 1) return null;
    return (
      <Menu
        key={"tripContextMenu"}
        open={tripMenuState?.open}
        onClose={closeTripContextMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          tripMenuState?.open
            ? { top: tripMenuState.y - 3, left: tripMenuState.x - 10}
            : undefined
        }
      >
        {buildMenuItems(menuItems, props.style, handleTripMenuSelection)}
      </Menu>
    );
  }

  const MxContextMenu = (props) => {
    if (!mxMenuState.open) {
      return <></>;
    }
    const menuItems = buildMxMenu(mxMenuState.maintenance);
    return (
      <Menu
        open={mxMenuState?.open}
        onClose={closeMxContextMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          mxMenuState?.open
            ? { top: mxMenuState.y, left: mxMenuState.x }
            : undefined
        }
      >
        {buildMenuItems(menuItems, props.style, handleMxMenuSelection)}
      </Menu>
    );
  }

  return {
    TripContextMenu,
    openTripContextMenu,
    MxContextMenu,
    openMxContextMenu
  };
}

export default ContextMenus;
export {
  buildTripMenu,
  buildMxMenu
}
